import { createFileRoute } from "@tanstack/react-router";

import EvidenceDetail from "@/pages/evidence/EvidenceDetail";

function EvidenceDetailPage() {
  const { caseId } = Route.useParams();
  return <EvidenceDetail caseId={caseId} />;
}

export const Route = createFileRoute("/evidence/$caseId")({
  component: EvidenceDetailPage,
});
